import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Accordion.scss';
import { AccordionItem, accordionItemExpandEvent, accordionItemName, accordionItemTagName, } from './components';
export const accordionName = 'Accordion';
export const accordionTagName = 'cell-component-accordion';
export class Accordion extends Component {
    constructor() {
        super(accordionName);
        this.handleAccordionItemExpand = this.handleAccordionItemExpand.bind(this);
    }
    componentDidMount() {
        // If autocollapse is enabled, subscribe to accordion item expand event, so we can collapse
        // other items.
        if (this.props.autocollapse) {
            this.subscribe(`${accordionItemName}.${accordionItemExpandEvent}`, this.handleAccordionItemExpand);
        }
    }
    handleAccordionItemExpand(_, event) {
        this.querySelectorAll(accordionItemTagName).forEach((accordionItem) => {
            // The accordion item is the one that just got expanded and therefore should stay expanded.
            if (accordionItem === event.target)
                return;
            // Sanity check to make sure we are dealing with an accordion item.
            if (!(accordionItem instanceof AccordionItem)) {
                throw new Error('The element to collapse is not an instance of AccordionItem.');
            }
            // Close all other accordion items.
            accordionItem.collapse();
        });
    }
}
defineComponent(accordionTagName, Accordion);
